import { AuthProvider } from './AuthProvider/AuthProvider'
import type { PropsWithChildren } from 'react'

export type ProvidersProps = PropsWithChildren<object>

export const Providers = ({ children }: ProvidersProps) => {
  return <AuthProvider defaultRedirect="/">{children}</AuthProvider>
}
